import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '../Button/Button'
import { InputContainer } from '../inputContainer/InputContainer'

export const AddCategory = ({ modalTitle, inputLabel, inputName, placeholderInput, invalidMessageInput, btnLabel, onChangeInput, onClickBtn }) => {
  const propsInput = () => ({
    type: 'text',
    valueInput: '',
    name: inputName,
    label: inputLabel,
    isRequired: true,
    isDisabled: false,
    placeholder: placeholderInput,
    invalidMessage: invalidMessageInput,
    onChange: onChangeInput
  })

  const propsBtn = () => ({
    kind: 'primary',
    disabled: false,
    onClick: onClickBtn
  })

  return (
    <>
      <div className='modal-header'><h2><span>{modalTitle}</span></h2></div>
      <div className='modal-body'>
        <InputContainer {...propsInput()} />
      </div>
      <div className='modal-footer'>
        <Button {...propsBtn()}>
          {`${btnLabel}`}
        </Button>
      </div>
  </>
  )
}

AddCategory.defaultProps = {
}

AddCategory.propTypes = {
  modalTitle: PropTypes.string,
  inputLabel: PropTypes.string,
  invalidMessageInput: PropTypes.string,
  placeholderInput: PropTypes.string,
  onChangeInput: PropTypes.func,
  onClickBtn: PropTypes.func,
  btnLabel: PropTypes.string
}
